import { render, staticRenderFns } from "./ClueFormPage.vue?vue&type=template&id=7643bf9c&scoped=true"
import script from "./ClueFormPage.vue?vue&type=script&lang=js"
export * from "./ClueFormPage.vue?vue&type=script&lang=js"
import style0 from "./ClueFormPage.vue?vue&type=style&index=0&id=7643bf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643bf9c",
  null
  
)

export default component.exports